export enum LogLevel {
    None,
    Error,
    Warn,
    Info,
    Debug,
    Trace,
}

export enum LogType {
    Console,
    File,
}
